import React from "react";
import Careers from "../components/Careers";

function CareersContainer() {
  return <Careers />;
}

export default CareersContainer;
